import { useRef } from 'react';

/**
 * Hook personalizado para detectar doble click o doble tap
 * @param {Function} callback - Función a ejecutar en doble click/tap
 * @param {number} delay - Tiempo máximo entre clicks en milisegundos (por defecto 300ms)
 * @returns {Function} - Handler para el evento onClick
 */
export const useDoubleClick = (callback, delay = 300) => {
  const clickTimeout = useRef(null);
  const clickCount = useRef(0);

  const handleClick = (event) => {
    clickCount.current += 1;

    if (clickCount.current === 1) {
      // Primer click - iniciar timeout
      clickTimeout.current = setTimeout(() => {
        // Si solo hubo un click, resetear el contador
        clickCount.current = 0;
      }, delay);
    } else if (clickCount.current === 2) {
      // Segundo click - ejecutar callback
      clearTimeout(clickTimeout.current);
      clickCount.current = 0;
      callback(event);
    }
  };

  return handleClick;
};
